<template>
  <div class="container">
    <canvas id="canvas" width="400" height="300" data-score='724'></canvas>
    <div class="user">
      <div style=" display: flex;     margin: auto 10px;">
        <div class="user_header">
          <van-image round fit="cover" width="10vh" height="10vh" :src="userInfo.headimgurl" />
        </div>
        <div class="user_info">
          <div class="user_info_name">
            {{ userInfo.nickname }}
          </div>
          <div class="user_info_phone">信用良好</div>
        </div>
      </div>
      <div class="user_his" @click="Jump()">
        历史信用
      </div>
    </div>
    <div class="introduce">
      <div class="introduce_title">停车信用积分介绍</div>
      <div class="introduce_text">
        停车信用分是根据您的停车行为（缴费次数、预约停车等维度），对您个人的信用进行综合评估得分，评分越高说明您的信用越高，可以享受更多信用权益。
      </div>
    </div>
    <div class="introduce">
      <div class="introduce_title">信用权益</div>
      <div class="introduce_text">
        敬请期待...
      </div>
    </div>
  </div>
</template>
<script>
import { Dialog } from 'vant'
import { addCarAndUserRel } from '@/api/park'
import { parseTime } from '@/utils'
import { mapGetters } from 'vuex'
export default {
  name: 'CreditScore',
  components: {
    [Dialog.Component.name]: Dialog.Component
  },
  computed: {
    ...mapGetters(['wx_userInfo', 'token', 'backflow', 'wx_portrait']),
    userInfo () {
      let temp = {
        nickname: '暂无',
        headimgurl: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
        phone: null
      }
      if (this.wx_portrait && this.wx_portrait.nickname) {// 微信头像昵称
        temp.nickname = this.wx_portrait.nickname
        temp.headimgurl = this.wx_portrait.headimgurl
        temp.hasData = true
        if (this.NBPSS && this.NBPSS.phone) {
          temp.phone = this.NBPSS.phone
        } else {
          temp.phone = null
        }
      } else if (this.NBPSS && this.NBPSS.phone) {
        temp.phone = this.NBPSS.phone
        if (this.NBPSS.name && this.NBPSS.picture1) {
          temp.nickname = this.NBPSS.name
          temp.headimgurl = this.NBPSS.picture1
        }
      } else {
        temp.hasData = false
      }
      return temp
    }
  },
  data () {
    return {
      getInfo_Loading: null,
      plateNumber: []
    }
  },
  methods: {
    Jump () {
      this.$toast('暂未开通 敬请期待！')
    },
    CreatEcharts () {
      var canvas = document.getElementById('canvas'),
        ctx = canvas.getContext('2d'),
        cWidth = canvas.width,
        cHeight = canvas.height,
        score = canvas.attributes['data-score'].value,
        stage = ['较差', '中等', '良好', '优秀', '极好'],
        radius = 150,
        deg0 = Math.PI / 9,
        deg1 = Math.PI * 11 / 45;

      if (score < 400 || score > 900) {
        alert('信用分数区间：400~900');
      } else {
        var dot = new Dot(),
          dotSpeed = 0.03,
          textSpeed = Math.round(dotSpeed * 100 / deg1),
          angle = 0,
          credit = 400;

        (function drawFrame () {

          ctx.save();
          ctx.clearRect(0, 0, cWidth, cHeight);
          ctx.translate(cWidth / 2, cHeight / 1.5);
          ctx.rotate(8 * deg0);

          dot.x = radius * Math.cos(angle);
          dot.y = radius * Math.sin(angle);

          var aim = (score - 400) * deg1 / 100;
          if (angle < aim) {
            angle += dotSpeed;
          }
          dot.draw(ctx);

          if (credit < score - textSpeed) {
            credit += textSpeed;
          } else if (credit >= score - textSpeed && credit < score) {
            credit += 1;
          }
          text(credit);

          ctx.save();
          ctx.beginPath();
          ctx.lineWidth = 3;
          ctx.strokeStyle = 'rgba(255, 255, 255, .5)';
          ctx.arc(0, 0, radius, 0, angle, false);
          ctx.stroke();
          ctx.restore();

          window.requestAnimationFrame(drawFrame);

          ctx.save(); //中间刻度层
          ctx.beginPath();
          ctx.strokeStyle = 'rgba(255, 255, 255, .2)';
          ctx.lineWidth = 10;
          ctx.arc(0, 0, 135, 0, 11 * deg0, false);
          ctx.stroke();
          ctx.restore();

          ctx.save(); // 刻度线
          for (var i = 0; i < 6; i++) {
            ctx.beginPath();
            ctx.lineWidth = 2;
            ctx.strokeStyle = 'rgba(255, 255, 255, .3)';
            ctx.moveTo(140, 0);
            ctx.lineTo(130, 0);
            ctx.stroke();
            ctx.rotate(deg1);
          }
          ctx.restore();

          ctx.save(); // 细分刻度线
          for (i = 0; i < 25; i++) {
            if (i % 5 !== 0) {
              ctx.beginPath();
              ctx.lineWidth = 2;
              ctx.strokeStyle = 'rgba(255, 255, 255, .1)';
              ctx.moveTo(140, 0);
              ctx.lineTo(133, 0);
              ctx.stroke();
            }
            ctx.rotate(deg1 / 5);
          }
          ctx.restore();

          ctx.save(); //信用分数
          ctx.rotate(Math.PI / 2);
          for (i = 0; i < 6; i++) {
            ctx.fillStyle = 'rgba(255, 255, 255, .4)';
            ctx.font = '10px Microsoft yahei';
            ctx.textAlign = 'center';
            ctx.fillText(400 + 100 * i, 0, -115);
            ctx.rotate(deg1);
          }
          ctx.restore();

          ctx.save(); //分数段
          ctx.rotate(Math.PI / 2 + deg0);
          for (i = 0; i < 5; i++) {
            ctx.fillStyle = 'rgba(255, 255, 255, .8)';
            ctx.font = '10px Microsoft yahei';
            ctx.textAlign = 'center';
            ctx.fillText(stage[i], 5, -115);
            ctx.rotate(deg1);
          }
          ctx.restore();

          ctx.save(); //信用阶段及评估时间文字
          ctx.rotate(10 * deg0);
          ctx.fillStyle = '#fff';
          ctx.font = '22px Microsoft yahei';
          ctx.textAlign = 'center';
          if (score < 500) {
            ctx.fillText('信用较差', 0, 40);
          } else if (score < 600 && score >= 500) {
            ctx.fillText('信用中等', 0, 40);
          } else if (score < 700 && score >= 600) {
            ctx.fillText('信用良好', 0, 40);
          } else if (score < 800 && score >= 700) {
            ctx.fillText('信用优秀', 0, 40);
          } else if (score <= 900 && score >= 800) {
            ctx.fillText('信用极好', 0, 40);
          }

          ctx.fillStyle = '#80cbfa';
          ctx.font = '14px Microsoft yahei';
          // ctx.fillText('评估时间：2016.11.06', 0, 60);

          ctx.fillStyle = '#7ec5f9';
          ctx.font = '14px Microsoft yahei';
          // ctx.fillText('BETA', 0, -60);
          ctx.restore();


          // ctx.save(); //最外层轨道
          ctx.beginPath();
          ctx.strokeStyle = 'rgba(255, 255, 255, .4)';
          ctx.lineWidth = 3;
          ctx.arc(0, 0, radius, 0, 11 * deg0, false);
          ctx.stroke();
          ctx.restore();

        })();
      }

      function Dot () {
        this.x = 0;
        this.y = 0;
        this.draw = function (ctx) {
          ctx.save();
          ctx.beginPath();
          ctx.fillStyle = 'rgba(255, 255, 255, .7)';
          ctx.arc(this.x, this.y, 3, 0, Math.PI * 2, false);
          ctx.fill();
          ctx.restore();
        };
      }

      function text (process) {
        ctx.save();
        ctx.rotate(10 * deg0);
        ctx.fillStyle = '#FFF';
        ctx.font = '65px Microsoft yahei';
        ctx.textAlign = 'center';
        ctx.textBaseLine = 'top';
        ctx.fillText(process, 0, 10);
        ctx.restore();
      }
    }
  },
  mounted () {
    this.CreatEcharts()
  }
}
</script>

<style lang="scss" scoped>
.container {
  height: 100vh;
  width: 100%;
  // position: relative;
  background: -webkit-linear-gradient(
    top,
    #5187f5 0%,
    #5dabf8 40%,
    #e0f4fb 60%,
    #e7e7e7 100%
  );
  background: -ms-linear-gradient(
    top,
    #5187f5 0%,
    #5dabf8 40%,
    #e0f4fb 60%,
    #e7e7e7 100%
  );
  background: -moz-linear-gradient(
    top,
    #5187f5 0%,
    #5dabf8 40%,
    #e0f4fb 60%,
    #e7e7e7 100%
  );
  background: linear-gradient(
    top,
    #5187f5 0%,
    #5dabf8 40%,
    #e0f4fb 60%,
    #e7e7e7 100%
  );
  canvas {
    position: relative;
    // transform: translate(-50%, -50%);
    // left: 50%;
    // top: 20%;
  }
  .user {
    margin: 20px;
    background: white;
    box-shadow: rgb(212, 212, 212) 1px 5px 10px;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    &_his {
      margin: auto 10px;
      width: 100px;
      text-align: center;
      height: 30px;
      line-height: 30px;
      font-size: 16px;
      background: rgb(201, 222, 255);
      color: rgb(112, 145, 255);
      padding: 3px;
      border-radius: 2px;
    }
    &_header {
      margin-top: 10px;
    }
    &_info {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      margin-left: 10px;
      &_name {
        font-size: 20px;
        font-weight: 500;
        margin-top: 10px;
      }
      &_phone {
        font-size: 14px;
        background: rgb(251, 197, 197);
        color: rgb(255, 112, 112);
        padding: 3px;
        border-radius: 2px;
        margin-bottom: 10px;
      }
    }
  }
  .introduce {
    margin: 20px;
    color: white;
    &_title {
      font-size: 20px;
      color: rgb(88, 88, 88);
      font-weight: 600;
      margin-bottom: 10px;
    }
    &_text {
      font-size: 15px;
      color: #bbb;
      line-height: 1.5;
    }
  }
}
</style>